import axios from "axios";

export default {
    async getEvents() {
        const data = new FormData();
        data.append("limit", "5");
        data.append("offset", "0");
        data.append("orderby", "events_calendar_date_start");
        data.append("orderdir", "desc");

        const response = await axios.post(`rest/v1/search/events_calendar`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        return response.data.data;
    },

    async setPartecipazione(data: Record<string, any>) {
        const response = await axios.post(`rest/v1/create/events_calendar_participant`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    async checkAdesione(eventId: string, userId: string) {
        const data = new FormData();
        data.append("where[events_calendar_participant_event_id]", eventId);
        data.append("where[events_calendar_participant_user]", userId);
        data.append("where[events_calendar_participant_confirm]", "1");

        const response = await axios.post(`rest/v1/search/events_calendar_participant`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response;
    },

    async getAdesioni(eventId: string) {
        console.log(eventId);
        const data = new FormData();
        data.append("where[events_calendar_participant_event_id]", eventId);
        data.append("where[events_calendar_participant_confirm]", "1");

        const response = await axios.post(`rest/v1/search/events_calendar_participant`, data, {
            headers: {
                Authorization: `${process.env.VUE_APP_TOKEN}`,
            },
        });
        //console.log(response);
        return response.data.data;
    },

    /** Pagamento quota partecipazione (Stripe / GetYourCash via CRM). */
    async createEventPaymentLink(
        eventId: string,
        userId: string,
        returnUrl?: string,
        additionalParticipants?: number,
        reqFromApp?: boolean,
    ) {
        const data = new FormData();
        data.append("event_id", eventId);
        data.append("user_id", userId);
        if (returnUrl) {
            data.append("return_url", returnUrl);
        }
        if (additionalParticipants !== undefined && additionalParticipants !== null) {
            const n = Math.max(0, Math.floor(Number(additionalParticipants)));
            data.append("additional_participants", String(Number.isNaN(n) ? 0 : n));
        }
        if (reqFromApp) {
            data.append("req_from_app", "1");
        }
        const response = await axios.post(
            `${process.env.VUE_APP_BASE_URL}events_calendar/event_payment/create_link`,
            data,
            {
                headers: {
                    Authorization: `${process.env.VUE_APP_TOKEN}`,
                },
            },
        );
        return response;
    },

    async getEventPaymentStatus(eventId: string, userId: string) {
        const data = new FormData();
        data.append("event_id", eventId);
        data.append("user_id", userId);
        const response = await axios.post(
            `${process.env.VUE_APP_BASE_URL}events_calendar/event_payment/payment_status`,
            data,
            {
                headers: {
                    Authorization: `${process.env.VUE_APP_TOKEN}`,
                },
            },
        );
        return response;
    },
};
